const {
    isSSR,
    getPlatform,
    isWebView,
    checkVersionSupport,
    isLegacyWebView,
} = require("./src/utils/platform")
const { injectCallback, injectCallbackContent } = require("./src/utils")

module.exports = Object.assign(
    {},
    {
        isSSR,
        getPlatform,
        isWebView,
        checkVersionSupport,
        isLegacyWebView,
        injectCallback,
        injectCallbackContent,
    }
)
